import { render, staticRenderFns } from "./InvalidGoods.vue?vue&type=template&id=31fc5034&scoped=true"
import script from "./InvalidGoods.vue?vue&type=script&lang=js"
export * from "./InvalidGoods.vue?vue&type=script&lang=js"
import style0 from "./InvalidGoods.vue?vue&type=style&index=0&id=31fc5034&prod&lang=scss&scoped=true"
import style1 from "./InvalidGoods.vue?vue&type=style&index=1&id=31fc5034&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fc5034",
  null
  
)

export default component.exports